export default __webpack_public_path__ + "graphics/cover--blurred.837ab5ea.jpg";